var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Label } from "@animech/ui";
import * as Styled from "./switch.style";
export var Switch = function (_a) {
    var heading = _a.heading, options = _a.options, value = _a.value, onValueChange = _a.onValueChange, _b = _a.offIndex, offIndex = _b === void 0 ? -1 : _b, props = __rest(_a, ["heading", "options", "value", "onValueChange", "offIndex"]);
    var handleChange = function (event) {
        var option = options[Number(event.target.value)];
        onValueChange(option.value);
    };
    return (_jsxs(Styled.Switch, { children: [heading && _jsxs(Label, { size: "small", children: [" ", heading, " "] }), _jsx("div", { className: "".concat(Styled.prefix, "-input-group"), children: options.map(function (option, index) { return (_jsxs("div", { className: "".concat(Styled.prefix, "-input"), children: [_jsx("input", __assign({ type: "radio", id: String(index), value: String(index), name: heading, checked: value === option.value, onChange: handleChange, disabled: option.disabled }, props)), _jsx("label", { className: index === offIndex ? "off" : "", htmlFor: String(index), children: option.label })] }, option.label)); }) })] }));
};
